const previewWrapper = {
  paddingBottom: '12px',
  display: 'flex',
  justifyContent: 'center',
}

const fileWrapper = {
  display: 'flex',
  justifyContent: 'center',
  maxWidth: 550,
  minWidth: 550,
}

const lapidaryVideo = {
  width: '100%',
  height: '100%',
  objectFit: 'contain',
}

const assets = {
  width: '550px',
  '.lapidary-video': {
    ...lapidaryVideo,
  },
}

const styles = {
  previewWrapper,
  fileWrapper,
  assets,
}

export { styles }
